import { Carousel, CarouselContent, CarouselItem } from '@repo/ui/carousel';
import { Skeleton } from '@repo/ui/skeleton';
import { cn } from '@repo/utils/cn';
import { memo } from 'react';
import CardSkeleton from '@/components/common/skeletons/card-skeleton';

type GamesCardsSkeletonProps = {
  isCarousel?: boolean;
  itemsCount?: number;
  className?: string;
  withTitle?: boolean;
};

const GamesCardsSkeleton = ({
  isCarousel = true,
  itemsCount = 6,
  withTitle = false,
  className,
}: GamesCardsSkeletonProps) => {
  if (!isCarousel) {
    return (
      <>
        {Array.from({ length: itemsCount }, (_, i) => (
          <CardSkeleton
            key={i}
            className={cn('size-full', className)}
          />
        ))}
      </>
    );
  }

  return (
    <section className={cn('flex w-full flex-col')}>
      {withTitle && (
        <div className="flex h-full w-3/4">
          <Skeleton className="h-8 w-28" />
        </div>
      )}
      <Carousel>
        <CarouselContent>
          {Array.from({ length: itemsCount }, (_, i) => (
            <CarouselItem
              key={i}
              className="w-1/3 basis-auto sm:w-1/4 md:w-1/5 lg:w-1/6 xl:w-[13.3333%]"
            >
              <CardSkeleton />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </section>
  );
};

export default memo(GamesCardsSkeleton);
